<template>
	<v-container>
		<v-row align="center" justify="center" v-if="loginStatus != 'loading'">
			<v-col cols="12" sm="8" md="6" lg="4">
				<v-card class="elevation-12">
					<v-toolbar dark color="primary">
						<v-toolbar-title>Авторизация</v-toolbar-title>
					</v-toolbar>
					<v-card-text>
						<v-form
							v-model="valid"
							ref="form"
						>
							<v-text-field
								v-model="username"
								id="username"
								prepend-icon="person"
								name="login"
								label="Электронная почта"
								type="text"
								v-on:keyup.enter="login"
								:rules="[ v => !!v || 'Обязательно']"
								:error-messages="usernameError"
							></v-text-field>
							<v-text-field
								v-model="password"
								id="password"
								prepend-icon="lock"
								name="password"
								label="Пароль"
								type="password"
								v-on:keyup.enter="login"
								:rules="[ v => !!v || 'Обязательно']"
							></v-text-field>
						</v-form>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							text
							color="primary"
							@click.prevent="forgotPassword"
						>
							Забыл пароль
						</v-btn>
						<v-btn
							color="primary"
							:loading="loading"
							@click.prevent="login"
						>
							<template v-slot:loader>
								<v-progress-circular
									indeterminate
									:size="27"
									:width="1"
								>{{ counter }}</v-progress-circular>
							</template>
							Войти
						</v-btn>
					</v-card-actions>
				</v-card>
				<v-alert
					v-model="loginAlert"
			      	color="error"
				>
					Неверный логин или пароль
    			</v-alert>
				<v-alert
					v-model="loginRestricted"
			      	color="warning"
				>
					На сайте проводятся технические работы, пожалуйста, вернитесь позже
    			</v-alert>
			</v-col>
		</v-row>
		<v-row align="center" justify="center" v-if="loginStatus == 'loading'">
			<v-col cols="12" sm="8" md="6" lg="4">
				<v-progress-linear :indeterminate="true" color="secondary"></v-progress-linear>
			</v-col>
		</v-row>
	</v-container>
</template>
<script>
	import axios from 'axios'
	import { api } from '../../lib/api'

	export default {
		data() {
			return {
				username: '',
				password: '',
				valid: true,
				attempts: 0,
				counter: 0,
				loading: false,
				usernameError: ''
			}
		},
		methods: {
			login() {
				if (this.$refs.form.validate()) {
					this.$store.dispatch('retrieveToken', {
						username: this.username,
						password: this.password
					})
					this.attempts++
				}
			},
			forgotPassword() {
				this.$refs.form.resetValidation()
				if (!this.username.length) {
					this.usernameError = 'Введите почту'
				}
				else {
					axios.post(api.path() + 'auth/forgot_password', {
						username: this.username
					})
					.then(response => {
						this.$store.dispatch('dialogNotify', {
							title: 'Проверьте почту',
							message: 'Письмо с восстановлением пароля отправлено на ' + this.username
								+ '.<br><br>Если эта почта соответствует активному пользователю, '
								+ 'вам придет письмо со ссылкой для восстановления пароля.'
						})
					})
				}
			},
			countdown() {
				setTimeout(() => {
					if (this.counter > 1) {
						this.counter--
						this.countdown()
					}
					else {
						this.loading = false
					}

				}, 1000)
			},
		},
		watch: {
			attempts(val) {
				if (val > 2) {
					this.loading = true
					this.counter = val + 10
					this.countdown()
				}
			}
		},
		computed: {
			loginStatus() {
				return this.$store.getters.loginStatus;
			},
			loginAlert() {
				return this.$store.getters.loginStatus == 'error'
			},
			loginRestricted() {
				return this.$store.getters.loginStatus == 'restricted'
			}
		},
		mounted() {
			document.querySelector("label\[for=\'username\'\]").classList.add('v-label--active')
			document.querySelector("label\[for=\'password\'\]").classList.add('v-label--active')
		}
	}
</script>
